module.exports = {
  "wrap": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0
  },
  "wxc-result": {
    "width": 750,
    "flex": 1,
    "alignItems": "center",
    "backgroundColor": "#f2f3f4"
  },
  "result-image": {
    "width": 320,
    "height": 320
  },
  "result-content": {
    "marginTop": 36,
    "alignItems": "center"
  },
  "content-text": {
    "fontSize": 30,
    "color": "#A5A5A5",
    "height": 42,
    "lineHeight": 42,
    "textAlign": "center"
  },
  "content-desc": {
    "marginTop": 10
  },
  "result-button": {
    "marginTop": 60,
    "borderWidth": 1,
    "borderColor": "#979797",
    "backgroundColor": "#FFFFFF",
    "borderRadius": 6,
    "width": 240,
    "height": 72,
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "button-text": {
    "color": "#666666",
    "fontSize": 30
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-c90fb922!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-result/index.vue
// module id = 141
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28